import Reflux from 'reflux';

const LoggersActions = Reflux.createActions({
  'loggers': {asyncResult: true},
  'subsystems': {asyncResult: true},
  'setSubsystemLoggerLevel': {asyncResult: true},
});

export default LoggersActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/src/actions/system/LoggersActions.jsx